import React, { useRef, useState } from "react";
import "./../../App.css";
import { useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import axios from "axios";
import base_url from "../../api/bootapi";
import Modal from "react-bootstrap/Modal";
import "react-phone-input-2/lib/style.css";

const howgpsused = [
  "Track the movement of a loved one for their safety",
  "Track someone because of potential infidelity",
  "Commercial Vehicle Tracking",
  "Theft prevention",
  "Other (please specify in the comments section)",
];
const cancellationreason = [
  "Service no longer needed",
  "Price concerns",
  "Not satisfied with tracking platform features (amcrestgps.com)",
  "Defective Unit",
  "Inaccurate, inconsistent readings",
  "Other (please specify in comments section)",
];
const CancellationOBDForm = () => {
  //------------------->Boolean States
  const [error, seterror] = useState(false);
  const [loader, setloader] = useState(false);
  const [success, setsuccess] = useState(false);
  const [imeierror, setimeierror] = useState(false);
  const [phoneerror, setphoneerror] = useState(false);
  const [inputloader, setinputloader] = useState(false);
  const [showsuccessmodal, setshowsuccessmodal] = useState(false);

  //------------------------>Data storing states
  const [phone, setPhone] = useState();
  const [comment, setcomment] = useState();
  const [message, setmessage] = useState();
  // const [imeidata, setimeidata] = useState({});

  //------------------------->Storing position of div ref
  const messagesEndRef = useRef(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });
  const checkphoneerror = (val) => {
    val ? setphoneerror(false) : setphoneerror(true);
  };

  const checkvalidimei = (val) => {
    if (Number(val)) {
      setinputloader(true);
      axios
        .get(`${base_url}/info/cancel/validate/${val}`)
        .then((res) => {
          setimeierror(false);
          setinputloader(false);
        })
        .catch((err) => {
          setinputloader(false);
          setimeierror(true);
        });
    }
  };
  const canceltracker = (data2) => {
    if (!phone) {
      setphoneerror(true);
      return;
    }
    setloader(true);
    let reason = "";
    data2.reasoncancellation.forEach((val, index) => {
      if (index + 1 === data2.reasoncancellation.length) {
        reason += val;
      } else {
        reason += val + ",";
      }
    });
    let gpstracker = "";
    data2.usegpstracker.forEach((val, index) => {
      if (index + 1 === data2.usegpstracker.length) {
        gpstracker += val;
      } else {
        gpstracker += val + ",";
      }
    });
    let data = {
      cancelation_reason: reason,
      comment: comment,
      email: data2.email,
      first_name: data2.firstName,
      how_gps_tracker: gpstracker,
      imei: data2.imei,
      last_name: data2.lastName,
      phone_number: phone,
    };
    axios
      .post(`${base_url}/auth/subscription/cancel`, data)
      .then((res) => {
        setloader(false);
        if (res.data.status) {
          seterror(false);
          let obj = { ...res.data.subscription };
          obj["email"] = data2.email;
          // setimeidata(obj);
          setshowsuccessmodal(true);
        } else {
          let error = res.data.message;
          if (res.data.error) error = error + " : " + res.data.error;
          setmessage(error);
          setsuccess(false);
          seterror(true);
          scrollToBottom();
        }
      })
      .catch((err) => {
        if (err.response) {
          let error = err.response.data?.message;
          if (err.response.data?.error) {
            error = error + " : " + err.response.data?.error;
          }
          setmessage(error);
        } else {
          setmessage("Something Went Wrong");
        }
        setsuccess(false);
        seterror(true);
        scrollToBottom();
        setloader(false);
      });
  };
  const handleCloseModal = () => {
    setshowsuccessmodal(false);
    setsuccess(true);
    scrollToBottom();
  };
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  // const handledormant = (val) => {
  //   window.open(
  //     `https://amcrestgps.net/gps-activation/#/activate-dormantfee?customer_id=${imeidata["customer_id"]}&imei=${imeidata["imei_no"]}&iccid=${imeidata["imei_iccid"]}&email=${imeidata["email"]}&paying=${val}`,
  //     "_blank"
  //   );
  // };
  return (
    <form id="myForm" onSubmit={handleSubmit(canceltracker)}>
      <div>
        <h4 className="cancellationobd_h4">
          Amcrest GPS Subscription Cancellation Form
        </h4>
        {loader ? (
          <img width={300} alt="loader" src="./loading.gif" />
        ) : (
          <div>
            <div className="form-group">
              <div className="row">
                <div className="col-md-6">
                  <input
                    {...register("firstName", { required: true })}
                    placeholder="First Name"
                    className="form-control"
                  />
                  {errors.firstName && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      FirstName is required
                    </span>
                  )}
                </div>
                <div className="col-md-6">
                  <input
                    {...register("lastName", { required: true })}
                    placeholder="Last Name"
                    className="form-control"
                  />
                  {errors.lastName && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      LastName is required
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="row">
                <div className="col-md-6">
                  <PhoneInput
                    country={"us"}
                    value={phone}
                    onChange={(phone) => setPhone(phone)}
                    placeholder="Contact Phone"
                    onBlur={(e) => checkphoneerror(e.target.value)}
                  />
                  {phoneerror && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      Phone Number is required
                    </span>
                  )}
                </div>
                <div className="col-md-6">
                  <input
                    {...register("email", { required: true })}
                    type="email"
                    placeholder="Email"
                    className="form-control"
                    style={{ position: "relative" }}
                  />
                  {inputloader ? (
                    <img
                      className="cancellation_inputloader"
                      src="./inputloader.gif"
                      width={50}
                      height={50}
                      alt="inputloader"
                    />
                  ) : null}
                  {errors.email && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      Email is required
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="row">
                <div className="col-md-12">
                  <input
                    {...register("imei", { required: true })}
                    placeholder="IMEI Number, Example: 860599000123456"
                    onChange={(e) => checkvalidimei(e.target.value)}
                    className="form-control"
                  />
                  {errors.imei && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      IMEI is required
                    </span>
                  )}
                  {imeierror && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      Invalid IMEI Please try with valid IMEI
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="row">
                <div className="col-md-5">
                  <p className="text-left">Reason(s) for Cancellation</p>
                </div>
                <div className="col-md-7 text-left">
                  {cancellationreason.map((item, index) => (
                    <div className="row" key={index + 1}>
                      <div className="col-md-1 paddingnone">
                        <input
                          type="checkbox"
                          {...register("reasoncancellation", {
                            required: true,
                          })}
                          value={item}
                        />
                      </div>
                      <div className="col-md-11 paddingnone">{item}</div>
                    </div>
                  ))}
                </div>
              </div>
              {errors.reasoncancellation && (
                <span className="errormessage">
                  <span>
                    <i
                      className="fa fa-times errorifont"
                      aria-hidden="true"
                    ></i>
                  </span>
                  Select atleast one checkbox from "Reason(s) for Cancellation"
                </span>
              )}
            </div>
            <div className="form-group">
              <div className="row">
                <div className="col-md-5">
                  <p className="text-left">How did you use your GPS tracker?</p>
                </div>
                <div className="col-md-7 text-left">
                  {howgpsused.map((item, index) => (
                    <div className="row" key={index + 1}>
                      <div className="col-md-1 paddingnone">
                        <input
                          {...register("usegpstracker", { required: true })}
                          type="checkbox"
                          value={item}
                        />
                      </div>
                      <div className="col-md-11 paddingnone">{item}</div>
                    </div>
                  ))}
                </div>
              </div>
              {errors.usegpstracker && (
                <span className="cancellationerrormessage">
                  <span>
                    <i
                      className="fa fa-times errorifont"
                      aria-hidden="true"
                    ></i>
                  </span>
                  Select atleast one checkbox from "How did you use your GPS
                  tracker?"
                </span>
              )}
            </div>
            <div className="form-group">
              <div className="row">
                <div className="col-md-12">
                  <textarea
                    {...register("comment", { required: true })}
                    value={comment}
                    onChange={(e) => setcomment(e.target.value)}
                    placeholder="Comments"
                    rows={6}
                    className="form-control"
                  />
                  {errors.comment && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      Comment is required
                    </span>
                  )}
                </div>
              </div>
            </div>
            {error ? (
              <div>
                <div className="alert alert-danger">
                  <strong>Error! </strong>
                  {message}
                </div>
              </div>
            ) : null}
            <div ref={messagesEndRef} />
            {success ? (
              <div>
                <div className="alert alert-success">
                  <strong>Success! </strong>
                  Your subscription cancellation request has been received and
                  processed. You will still be able to track until the end of
                  your billing cycle.
                </div>
                {/* <div className="alert alert-warning text-left">
                  <h5 className="form-main">
                    We wanted to let you know that when you cancel your
                    subscription, you have the option of either{" "}
                    <strong>"totally cancelling"</strong> and deactivating your
                    sim card, or placing the sim card in{" "}
                    <strong>"dormant mode"</strong>.
                  </h5>
                  <h5 className="form-main">
                    Placing it in <strong>"dormant mode"</strong> has the
                    advantage that the sim card will remain active and you can
                    enable it again in the future.
                  </h5>
                  <h5 className="form-main">
                    If you do not want this and want to{" "}
                    <strong>"totally cancelling"</strong> then please click the
                    link below to <strong>"Totally cancel"</strong>.
                  </h5>
                  <div className="d-flex justify-content-end">
                    <div
                      className="btn btn-danger"
                      onClick={() => handledormant("no")}
                    >
                      Totally Cancel
                    </div>
                    <div
                      className="btn btn-success ml-2"
                      onClick={() => handledormant("yes")}
                    >
                      Enable Dormant Mode
                    </div>
                  </div>
                </div> */}
              </div>
            ) : (
              <div
                className="activation"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div></div>
                <button className={"btn btn-primary"} type="submit">
                  Submit
                </button>
              </div>
            )}
          </div>
        )}
      </div>
      <Modal
        size="md"
        show={showsuccessmodal}
        onHide={() => handleCloseModal()}
        backdrop="static"
      >
        <Modal.Header closeButton={() => handleCloseModal()}>
          <Modal.Title style={{ color: "#3947e6" }}>
            Successfully Cancelled!!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className="form-main" style={{ color: "#3947e6" }}>
            Your subscription cancellation request has been received and
            processed. You will still be able to track until the end of your
            billing cycle.
          </h5>
          {/* <h5 className="form-main" style={{ color: "#3947e6" }}>
            We wanted to let you know that when you cancel your subscription,
            you have the option of either <strong>"totally cancelling"</strong>{" "}
            and deactivating your sim card, or placing the sim card in{" "}
            <strong>"dormant mode"</strong>.
          </h5>
          <h5 className="form-main" style={{ color: "#3947e6" }}>
            Placing it in <strong>"dormant mode"</strong> has the advantage that
            the sim card will remain active and you can enable it again in the
            future.
          </h5>
          <h5 className="form-main" style={{ color: "#3947e6" }}>
            If you do not want this and want to{" "}
            <strong>"totally cancelling"</strong> then please click the link
            below to <strong>"Totally cancel"</strong>.
          </h5>
          <div className="d-flex justify-content-end">
            <div className="btn btn-danger" onClick={() => handledormant("no")}>
              Totally Cancel
            </div>
            <div
              className="btn btn-success ml-2"
              onClick={() => handledormant("yes")}
            >
              Enable Dormant Mode
            </div>
          </div> */}
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => handleCloseModal()}
            type="button"
            className="btn btn-primary"
          >
            Ok
          </button>
        </Modal.Footer>
      </Modal>
    </form>
  );
};

export default CancellationOBDForm;
